import { IDataLayer, LayerViewModel, MgrLayer, numericTextSort } from "../omnia"

export function setupLayers(layers: IDataLayer[], layerViewModelFactory: (l: IDataLayer) => LayerViewModel): MgrLayer[] {

    let result = layers.map(l => {

        const vm = layerViewModelFactory(l)

        const year = vm.year || vm.date?.getFullYear() || vm.cropping?.yearId

        const layer: MgrLayer = {

            id: l.DataLayerId,
            typeId: l.TypeId,
            text: vm.description,
            layer: l,
            selected: false,

            year,
            inactive: !!l.Inactive,

            vm

        }

        return layer

    })

    result = numericTextSort(result, r => r.vm.fieldName || "")

    return result

}
